// extracted by mini-css-extract-plugin
export default {"bigNumber":"ALI0VGPWYJSAMkmL4de9"};